import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import swal from 'sweetalert2';

@Component({
  selector: 'app-guest-contact-list',
  templateUrl: './guest-contact-list.component.html',
  styleUrls: ['./guest-contact-list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class GuestContactListComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;
  user_role:any
  @ViewChild('name') inputName;
  searchVal:any
  row_data:any

  guideline_data:any

  referral_model ={
    refrence: '',
    report_to: '',
    notes: '',
    admin_notes: '',
  }
  referral_model_notes =''
  referral_model_admin_notes =''

  emp_list =[]
  row_name:any
  user_idd:any
  form_data = new FormData()
  isRefral:any= true
  userId:any
  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,
              private session:SessionStorageService,
              private route: Router ) { 
              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              let key_data = setting_data.filter((item) => item.key == 'Contacts') 
              this.guideline_data = key_data[0]?._id
              }

  ngOnInit(): void {
    this.getContactList()
    this.getFullAndPartTimeEmp()
   
  }
  editContact(row){
    this.route.navigate(['/contact/edit',row?._id])
  }
  getContactList(){
    this.apiService.getGuestContactList(this.page.pageNumber +1,this.limitRef).subscribe((res:any)=>{
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  pageChangeData(page:any) {
    this.apiService.getContactList(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.rows =res.data.items
      this.page.totalPages=res.data.totalCount
    }) 
  }
  filter(val){
    
    if(val){
      this.apiService.contactSearch(val).subscribe((res:any)=>{
        this.rows = res?.data
        this.page.totalPages = res?.data?.length
      })
    }
   
  }
  resetFilter(){
    this.inputName.nativeElement.value=null
    this.getContactList()
  }
 
  deleteContact(id,password){
      this.apiService.deleteContact(id,password).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
          this.getContactList()
        }
        })
  }

     // ================== Delete Alert ========================
     Delete(id: any) {
      swal.fire({
        text: "Please Enter Password",
        input: 'password',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteContact(id,result.value)
  
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }

  openModal(content,data){
    this.row_data = data
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  getFullAndPartTimeEmp(){
    this.apiService.getFullPartEmployeeList(1,100).subscribe((res:any)=>{
      this.emp_list = res?.items
    })
  }
  getEmpId(event){
    this.referral_model.report_to 

  }
  openModalForReferral(content,userId,name) {
    this.row_name = name
    this.referral_model.refrence = `${this.user_role.id}`
    this.user_idd = userId
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    
    const modalRef = this.modalService.open(content,options);

    modalRef.result.then((result) => {
      this.referral_model.report_to = null
      this.referral_model.refrence = null
      this.user_idd = null
      this.form_data = new FormData()
    }, (reason) => {
      this.referral_model.report_to = null
      this.referral_model.refrence = null
      this.user_idd = null
      this.form_data = new FormData()
    });
  }
  
  addReferral(){
    this.form_data.append('ref_status','referal')
    this.form_data.append('report_to',this.referral_model?.report_to )
    this.form_data.append('notes',this.referral_model?.notes)
    this.form_data.append('admin_notes',this.referral_model?.admin_notes)
    this.form_data.append('is_refral',this.isRefral)
    this.form_data.append('refrence_by',this.user_role.id)

    this.apiService.updateUser(this.user_idd ,this.form_data).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.getContactList()
      }
      else this.toastr.error(res?.error)
    })
  }

  setDefaultPassword(id:any,name:string){
    this.userId=id
    if(this.userId){
      this.apiService.changePasswordEnrolment(this.userId).subscribe((res:any)=>{
        if (res.isSuccess === true) {
          this.toastr.success(res.message)
          swal.fire({
            title: "Success!",
            text: `${name} your password is combination of name's first 4 letters (capital) and phone number's last 4 digits`,
            icon: "success",
            customClass: {
              confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false,
          });
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }    
  }
  copyToClipboard(name:any,phone:any) {
    let n= name.substring(0,4).toUpperCase();
    let p=phone.substring(6)
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value =n+p
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Password copied')
  }

  setNewPassowrd(newPassword){
    if(this.userId){
      let body={
        newPassword:newPassword
      }
      this.apiService.changePassword(this.userId,body).subscribe((res:any)=>{
        if (res.isSuccess === true) {
          this.toastr.success(res.message)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }    
  }
  changePassword(id:any){
    this.userId=id
    swal.fire({
      text: "Set New Password",
      input: 'text',
      showCancelButton: true,
    }).then( (result)=> {
      if (result.value) {  
        if(id ){
          this.setNewPassowrd(result.value)
        }    
      } 
      else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }


}
